<template>
  <div class="card" itemprop="review" itemscope
       itemtype="https://schema.org/Review">
    <div class="card-body" @click="showMode = true;">

      <div itemprop="author" itemscope
           itemtype="https://schema.org/Person">
        <p itemprop="name" class="author-name">
          {{
            review.client.client_name && review.client.client_name.length > 0 ? review.client.client_name : $t('Anonymous')
          }}
        </p>
      </div>

      <p itemprop="datePublished" class="created_at text-capitalize">{{ $t('Hodnotene') }}
        {{ (new Date(review.created_at)).toLocaleString('sk-SK', {year: 'numeric', month: 'long'}) }}</p>


      <div class="stars-count">

        <div class="badge badge-pill badge-reviews"
             :class="{'bg-warning': review.rating >3 && review.rating <= 4 , 'bg-success': review.rating > 4, 'bg-danger': review.rating <=3 }">
          {{ Number(review.rating).toFixed(1).replace('.', ',') }}
        </div>

        <div class="user-rating-count-stars">
          <div class="default-rating-star">
            <TyIcon icon="ty-star"/>
            <TyIcon icon="ty-star"/>
            <TyIcon icon="ty-star"/>
            <TyIcon icon="ty-star"/>
            <TyIcon icon="ty-star"/>
          </div>

          <div class="user-rating-star">
            <div class="rating-star" v-for="star in Math.round(Number(review.rating))">
              <TyIcon icon="ty-star"/>
            </div>
          </div>

        </div>
      </div>

      <div itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating"
           class="d-none">
        <meta itemprop="worstRating" content="1">
        <span itemprop="ratingValue">{{ Number(review.rating) }}</span>/
        <span itemprop="bestRating">5</span>stars
      </div>


      <div class="text">

        <p class="text-dark text-wrap" itemprop="reviewBody">
          {{ review?.lang_text[activeLocale.code] ?? review.text }}
        </p>
      </div>

      <template v-if="showMode">
        <div class="more">
          <div class="row">
            <div class="col-12 col-md-6">
              <p v-if="review.recommendation && review.recommendation.length > 0 && admin_view === true">
                <strong>{{ $t('co-by-ste-zlepsili') }}</strong><br>
                {{ review.recommendation }}
              </p>
              <p v-if="review.location_tips && review.location_tips.length > 0">
                <strong>{{ $t('add-review-location-label') }}</strong><br>
                {{ review.location_tips }}
              </p>
              <p v-if="review.visited_in">
                <strong>{{ $t('add-review-visited-with-caption') }}</strong><br>
                {{ $t(`visited-with-${review.visited_in}`) }}
              </p>
            </div>
            <div class="col-12 col-md-6">
              <div class="user-rating-count-stars d-block w-100">
                <template v-for="code in Object.keys(StarTypes).filter(code => review.type_rating[code] > 0)">
                  <div class="row">
                    <div class="col-12">
                      <div class="review_additional">
                        <div class="title">
                          {{ $t('review-star-type-' + code) }}
                        </div>
                        <div class="stars user-rating-star d-block position-relative">
                          <div class="rating-star" v-for="star in Math.round(review.type_rating[code])">
                            <TyIcon icon="ty-star"/>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">

import {PropType} from "vue";
import AccommodationReview from "../../../../../../lib/models/AccommodationReview";
import StarTypes from '~/lib/data/review_rating_start_types.json';

const props = defineProps({
  review: Object as PropType<AccommodationReview>,
  activeLocale: {code: String},
  admin_view: Boolean,
});

const showMode = ref(false);

</script>

